import { environment } from '@env';

interface props {
  userId: string;
  onLoad: (...args) => void;
  onError?: (...args) => void;
}

export const ImageLoader = ({ userId, onLoad, onError }: props) => {
  if (!userId) {
    return <></>;
  }
  const url = `${environment.API_URL}public/image/${userId}`;
  return (
    <img
      height="100px"
      width="100px"
      crossOrigin="anonymous"
      onLoad={onLoad}
      onError={onError}
      alt="hidden"
      hidden
      src={url}
    />
  );
};
